var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9927C32 7.15612 24.8366 -0.00732422 16 -0.00732422C7.16344 -0.00732422 0 7.15612 0 15.9927C0 24.8292 7.16344 31.9927 16 31.9927C24.8366 31.9927 32 24.8292 32 15.9927Z",
    fill: "#001D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98292 11.1895C10.1913 11.1895 11.1709 10.2099 11.1709 9.00148C11.1709 7.79308 10.1913 6.81348 8.98292 6.81348C7.77452 6.81348 6.79492 7.79308 6.79492 9.00148C6.79492 10.2099 7.77452 11.1895 8.98292 11.1895Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2372 12.8479V24.9869H17.0062V18.9839C17.0062 17.3999 17.3042 15.8659 19.2682 15.8659C21.2052 15.8659 21.2292 17.6769 21.2292 19.0839V24.9879H25.0002V18.3309C25.0002 15.0609 24.2962 12.5479 20.4742 12.5479C18.6392 12.5479 17.4092 13.5549 16.9062 14.5079H16.8552V12.8479H13.2372ZM7.09521 12.8479H10.8702V24.9869H7.09521V12.8479Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 -0.00732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.933d45f2e5da98a68b64c35fcc2a0525.svg";
export { ForwardRef as ReactComponent };